(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (window.HP) return;
  const root = document.documentElement;
  let config = {};
  try { config = JSON.parse(document.getElementById('hp-runtime')?.textContent || '{}'); } catch {}
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const cleanups = new WeakMap();
  const initHooks = [];
  const HP = window.HP = {
    config, all, reduced, fine, initHooks,
    text: (key, values = {}) => Object.entries(values).reduce((text, [k, v]) => text.replaceAll('__' + k + '__', String(v)), config.text?.[key] || key),
    parse: html => new DOMParser().parseFromString(html, 'text/html'),
    url(value) { const url = new URL(value, document.baseURI); if (url.origin !== new URL(document.baseURI).origin) throw new Error('Invalid storefront URL'); return url; },
    init(scope = document) { initHooks.forEach(fn => fn(scope)); },
    money(amount) { return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'INR' }).format(Number(amount) / 100); }
  };
  root.classList.replace('no-js', 'js');
  let toastTimer;
  HP.toast = message => {
    const node = document.getElementById('hp-toast');
    if (!node) return;
    clearTimeout(toastTimer);
    node.textContent = message;
    node.classList.add('is-visible');
    toastTimer = setTimeout(() => node.classList.remove('is-visible'), 5500);
  };
  const returnFocus = new WeakMap();
  const closing = new WeakMap();
  const entering = new WeakMap();
  HP.open = (id, trigger) => {
    const dialog = typeof id === 'string' ? document.getElementById(id) : id;
    if (!dialog || dialog.open) return;
    clearTimeout(closing.get(dialog));
    clearTimeout(entering.get(dialog));
    dialog.classList.remove('is-closing');
    dialog.classList.add('is-entering');
    entering.set(dialog, setTimeout(() => dialog.classList.remove('is-entering'), 850));
    dialog.style.removeProperty('--hp-sheet-y');
    returnFocus.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    document.body.classList.add('hp-modal-open');
    cursorHide();
    requestAnimationFrame(() => { if (dialog.open && !dialog.classList.contains('is-closing')) (dialog.querySelector('[data-dialog-focus]') || dialog.querySelector('input:not([type=hidden]),[autofocus],button'))?.focus({ preventScroll: true }); });
    HP.init(dialog);
    document.dispatchEvent(new CustomEvent('hp:dialog-open', { detail: dialog }));
  };
  HP.close = (dialog, immediate = false) => {
    if (!dialog?.open) return;
    clearTimeout(closing.get(dialog));
    clearTimeout(entering.get(dialog));
    dialog.classList.remove('is-entering');
    const finish = () => {
      dialog.close();
      dialog.classList.remove('is-closing');
      dialog.style.removeProperty('--hp-sheet-y');
      document.body.classList.toggle('hp-modal-open', !!document.querySelector('dialog[open]'));
      const trigger = returnFocus.get(dialog);
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    };
    if (immediate || reduced.matches || root.dataset.motion === 'false') finish();
    else { dialog.classList.add('is-closing'); closing.set(dialog, setTimeout(finish, 330)); }
  };
  const preparedDialogs = new WeakSet();
  const prepareDialogs = scope => all('dialog', scope).forEach(dialog => {
    if (preparedDialogs.has(dialog)) return;
    preparedDialogs.add(dialog);
    dialog.addEventListener('cancel', event => { event.preventDefault(); HP.close(dialog); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) HP.close(dialog);
    });
    dialog.addEventListener('close', () => document.body.classList.toggle('hp-modal-open', !!document.querySelector('dialog[open]')));
    const handle = dialog.querySelector('[data-drag-handle]');
    if (!handle) return;
    let start = null;
    handle.addEventListener('pointerdown', event => { start = event.clientY; handle.setPointerCapture?.(event.pointerId); });
    handle.addEventListener('pointermove', event => { if (start !== null) dialog.style.setProperty('--hp-sheet-y', Math.max(0, event.clientY - start) + 'px'); });
    const release = event => {
      if (start === null) return;
      if (event.clientY - start > 70) HP.close(dialog);
      else dialog.style.removeProperty('--hp-sheet-y');
      start = null;
    };
    handle.addEventListener('pointerup', release);
    handle.addEventListener('pointercancel', () => { start = null; dialog.style.removeProperty('--hp-sheet-y'); });
  });
  initHooks.push(prepareDialogs);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener && !(opener.dataset.openDialog === 'hp-cart' && config.cartDrawer === false)) {
      event.preventDefault();
      HP.open(opener.dataset.openDialog, opener);
    }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) HP.close(closer.closest('dialog'));
    const zoom = event.target.closest('[data-image-zoom]');
    if (zoom) {
      const image = document.querySelector('[data-zoom-image]');
      image.src = zoom.dataset.imageZoom;
      image.alt = zoom.dataset.imageAlt || '';
      HP.open('hp-zoom', zoom);
    }
  });
  const navigationReady = new WeakSet();
  initHooks.push(scope => all('[data-navigation]', scope).forEach(header => {
    if (navigationReady.has(header)) return;
    navigationReady.add(header);
    const nav = header.querySelector('[data-nav-list]');
    const viewport = header.querySelector('[data-nav-viewport]');
    const backdrop = header.querySelector('[data-nav-backdrop]');
    const indicator = header.querySelector('[data-nav-indicator]');
    const items = all('[data-nav-item]', nav);
    const panels = all('[data-nav-panel]', viewport);
    if (!nav || !viewport || !backdrop || !indicator || !items.length) return;
    const desktop = matchMedia('(min-width: 1024px)');
    const controller = new AbortController();
    const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: controller.signal });
    const panelTimers = new Map();
    let activeKey = null;
    let highlighted = null;
    let hoverTimer;
    let leaveTimer;
    let closeTimer;
    let enterFrame;
    let resizeFrame;
    let destroyed = false;
    const animated = () => !reduced.matches && root.dataset.motion !== 'false';
    const itemFor = key => items.find(item => item.dataset.navItem === key);
    const panelFor = key => panels.find(panel => panel.dataset.navPanel === key);
    const currentItem = () => items.find(item => item.querySelector('[aria-current="page"]'));
    const focusables = panel => all('a[href],button:not(:disabled)', panel).filter(node => !node.hidden && !node.closest('[hidden]'));
    const cancelHover = () => { clearTimeout(hoverTimer); clearTimeout(leaveTimer); };
    const highlight = item => {
      highlighted = item || null;
      items.forEach(node => node.classList.toggle('is-highlighted', node === item));
      if (!item || !desktop.matches) { indicator.classList.remove('is-visible'); return; }
      const bounds = nav.getBoundingClientRect();
      const rect = item.getBoundingClientRect();
      indicator.style.setProperty('--hp-nav-x', `${rect.left - bounds.left}px`);
      indicator.style.setProperty('--hp-nav-y', `${rect.top - bounds.top}px`);
      indicator.style.width = `${rect.width}px`;
      indicator.style.height = `${rect.height}px`;
      indicator.classList.add('is-visible');
    };
    const hidePanel = panel => {
      clearTimeout(panelTimers.get(panel));
      panelTimers.delete(panel);
      panel.hidden = true;
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-active', 'is-leaving');
    };
    const measure = panel => {
      const bounds = header.getBoundingClientRect();
      const item = itemFor(panel.dataset.navPanel).getBoundingClientRect();
      const maxWidth = Math.max(0, bounds.width - 32);
      let width = bounds.width;
      if (panel.dataset.navLayout === 'compact') width = Math.min(380, maxWidth);
      if (panel.dataset.navLayout === 'collections') width = Math.min(bounds.width, Math.max(540, panel.querySelectorAll('.hp-nav-collection').length * 236 + 56));
      const left = width >= bounds.width ? 0 : Math.max(16, Math.min(bounds.width - width - 16, item.left - bounds.left + item.width / 2 - width / 2));
      const available = Math.max(100, innerHeight - bounds.bottom - 20);
      panel.style.width = `${width}px`;
      panel.style.maxHeight = `${available}px`;
      viewport.style.width = `${width}px`;
      viewport.style.left = `${left}px`;
      viewport.style.height = `${Math.min(available, panel.scrollHeight || panel.getBoundingClientRect().height)}px`;
      header.style.setProperty('--hp-nav-top', `${Math.max(0, bounds.bottom)}px`);
    };
    const close = (immediate = false, restore = false) => {
      cancelHover();
      clearTimeout(closeTimer);
      cancelAnimationFrame(enterFrame);
      const previous = itemFor(activeKey);
      const focused = viewport.contains(document.activeElement);
      activeKey = null;
      header.classList.remove('has-open-navigation');
      viewport.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      items.forEach(item => item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', 'false'));
      panels.forEach(panel => { panel.inert = true; panel.setAttribute('aria-hidden', 'true'); panel.classList.remove('is-active'); });
      const finish = () => { viewport.hidden = true; backdrop.hidden = true; panels.forEach(hidePanel); };
      if (immediate || !animated()) finish();
      else closeTimer = setTimeout(finish, 240);
      highlight(currentItem());
      if ((restore || focused) && previous && !document.querySelector('dialog[open]')) previous.querySelector('[data-nav-link]').focus({ preventScroll: true });
    };
    const show = (key, focus = null) => {
      cancelHover();
      if (!desktop.matches || document.querySelector('dialog[open]')) return;
      const item = itemFor(key);
      const panel = panelFor(key);
      if (!panel) { close(); highlight(item); return; }
      clearTimeout(closeTimer);
      highlight(item);
      if (activeKey === key) {
        if (focus) (focus === 'last' ? focusables(panel).at(-1) : focusables(panel)[0])?.focus({ preventScroll: true });
        return;
      }
      const previous = panelFor(activeKey);
      const previousIndex = items.indexOf(itemFor(activeKey));
      const direction = previousIndex < 0 || items.indexOf(item) >= previousIndex ? 1 : -1;
      const moveFocus = previous?.contains(document.activeElement);
      activeKey = key;
      cancelAnimationFrame(enterFrame);
      panels.forEach(node => {
        clearTimeout(panelTimers.get(node));
        if (node === panel) return;
        if (!node.hidden && animated()) {
          node.style.setProperty('--hp-nav-direction', String(direction));
          node.classList.remove('is-active');
          node.classList.add('is-leaving');
          node.inert = true;
          node.setAttribute('aria-hidden', 'true');
          panelTimers.set(node, setTimeout(() => hidePanel(node), 210));
        } else hidePanel(node);
      });
      panel.hidden = false;
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.remove('is-active', 'is-leaving');
      panel.style.setProperty('--hp-nav-direction', String(direction));
      viewport.hidden = false;
      backdrop.hidden = false;
      header.classList.add('has-open-navigation');
      items.forEach(node => node.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', String(node === item)));
      measure(panel);
      const enter = () => {
        if (activeKey !== key || destroyed) return;
        viewport.classList.add('is-open');
        backdrop.classList.add('is-visible');
        panel.classList.add('is-active');
      };
      if (animated()) enterFrame = requestAnimationFrame(() => { enterFrame = requestAnimationFrame(enter); });
      else enter();
      if (focus) (focus === 'last' ? focusables(panel).at(-1) : focusables(panel)[0])?.focus({ preventScroll: true });
      else if (moveFocus) item.querySelector('[data-nav-link]').focus({ preventScroll: true });
    };
    const resize = () => {
      if (destroyed) return;
      if (!desktop.matches) { close(true); return; }
      highlight(highlighted || currentItem());
      if (activeKey) measure(panelFor(activeKey));
    };
    const queueResize = () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(resize); };
    panels.forEach(hidePanel);
    items.forEach(item => {
      const toggle = item.querySelector('[data-nav-toggle]');
      if (toggle) toggle.hidden = false;
      listen(item, 'pointerenter', event => {
        if (!fine.matches || event.pointerType === 'touch' || !desktop.matches) return;
        cancelHover();
        highlight(item);
        hoverTimer = setTimeout(() => show(item.dataset.navItem), 65);
      });
      listen(item, 'pointerleave', () => clearTimeout(hoverTimer));
      if (toggle) listen(toggle, 'click', () => {
        if (activeKey === item.dataset.navItem) close(false, true);
        else show(item.dataset.navItem);
      });
    });
    listen(header, 'pointerenter', () => clearTimeout(leaveTimer));
    listen(viewport, 'pointerenter', () => { cancelHover(); highlight(itemFor(activeKey)); });
    listen(header, 'pointerleave', event => {
      cancelHover();
      if (event.pointerType === 'touch' || viewport.contains(document.activeElement)) return;
      leaveTimer = setTimeout(() => close(), 200);
    });
    listen(backdrop, 'pointerenter', () => { if (fine.matches && !viewport.contains(document.activeElement)) { cancelHover(); leaveTimer = setTimeout(() => close(), 200); } });
    listen(header, 'focusin', event => {
      clearTimeout(leaveTimer);
      const item = event.target.closest('[data-nav-item]');
      if (item) { highlight(item); if (activeKey && activeKey !== item.dataset.navItem) show(item.dataset.navItem); }
      else if (!viewport.contains(event.target)) close();
    });
    listen(header, 'focusout', event => {
      if (event.relatedTarget && !header.contains(event.relatedTarget)) close();
    });
    listen(header, 'keydown', event => {
      const item = event.target.closest('[data-nav-item]');
      if (event.key === 'Escape' && activeKey) { event.preventDefault(); event.stopPropagation(); close(false, true); }
      if (item && ['ArrowDown', 'ArrowUp'].includes(event.key) && panelFor(item.dataset.navItem)) {
        event.preventDefault(); show(item.dataset.navItem, event.key === 'ArrowUp' ? 'last' : 'first');
      }
      if (item && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        const index = (items.indexOf(item) + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
        items[index].querySelector('[data-nav-link]').focus({ preventScroll: true });
      }
      if (event.key !== 'Tab' || !activeKey) return;
      const panel = panelFor(activeKey);
      const links = focusables(panel);
      if (item?.dataset.navItem === activeKey && !event.shiftKey) { event.preventDefault(); links[0]?.focus(); }
      else if (event.target === links[0] && event.shiftKey) { event.preventDefault(); itemFor(activeKey).querySelector('[data-nav-link]').focus(); }
      else if (event.target === links.at(-1) && !event.shiftKey) {
        event.preventDefault();
        const next = items[items.indexOf(itemFor(activeKey)) + 1]?.querySelector('[data-nav-link]') || header.querySelector('.hp-header-actions a');
        close(true);
        next?.focus();
      }
    });
    listen(document, 'pointerdown', event => { if (!header.contains(event.target) || event.target === backdrop) close(); });
    listen(viewport, 'click', event => { if (event.target.closest('a[href]')) close(true); });
    listen(nav, 'click', event => { if (event.target.closest('[data-nav-link]')) close(true); });
    listen(document, 'hp:dialog-open', () => close(true));
    listen(document, 'hp:motion-change', () => { if (!animated()) { if (activeKey) { panels.forEach(panel => { if (panel.dataset.navPanel !== activeKey) hidePanel(panel); }); panelFor(activeKey).classList.add('is-active'); viewport.classList.add('is-open'); backdrop.classList.add('is-visible'); } else close(true); } });
    listen(window, 'resize', queueResize, { passive: true });
    listen(window, 'scroll', queueResize, { passive: true });
    listen(window, 'blur', () => close(true));
    const observer = 'ResizeObserver' in window ? new ResizeObserver(queueResize) : null;
    observer?.observe(nav);
    panels.forEach(panel => observer?.observe(panel));
    header.classList.add('hp-nav-ready');
    highlight(currentItem());
    document.fonts?.ready.then(() => { if (!destroyed) resize(); });
    cleanups.set(header, () => {
      destroyed = true;
      controller.abort();
      observer?.disconnect();
      cancelHover();
      clearTimeout(closeTimer);
      panelTimers.forEach(timer => clearTimeout(timer));
      cancelAnimationFrame(enterFrame);
      cancelAnimationFrame(resizeFrame);
    });
  }));

  let revealObserver;
  const splitHeading = heading => {
    if (heading.classList.contains('hp-split-ready')) return;
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    let index = 0;
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(word => {
        if (!word || /^\s+$/.test(word)) fragment.append(document.createTextNode(word));
        else {
          const clip = document.createElement('span');
          const inner = document.createElement('span');
          clip.className = 'hp-split-clip';
          inner.className = 'hp-word';
          inner.textContent = word;
          inner.style.setProperty('--hp-word-delay', `${250 + Math.min(index++, 12) * 30}ms`);
          clip.append(inner);
          fragment.append(clip);
        }
      });
      node.replaceWith(fragment);
    });
    heading.classList.add('hp-split-ready');
  };
  const prepareReveals = scope => {
    const enabled = root.dataset.motion !== 'false' && !reduced.matches;
    all('[data-split]', scope).forEach(splitHeading);
    all('[data-reveal],[data-split],[data-reveal-image]', scope).forEach(node => {
      if (!enabled || !revealObserver || node.closest('dialog')) node.classList.add('is-revealed');
      else if (!node.classList.contains('is-revealed')) revealObserver.observe(node);
    });
  };
  if ('IntersectionObserver' in window) revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealObserver.unobserve(entry.target); }
  }), { threshold: .07, rootMargin: '0px 0px -25px 0px' });
  initHooks.push(prepareReveals);
  const updateMotion = () => {
    root.dataset.motionActive = String(root.dataset.motion !== 'false' && !reduced.matches);
    root.dataset.cursorActive = String(root.dataset.cursor !== 'false' && root.dataset.motionActive === 'true' && fine.matches && innerWidth > 749);
    if (root.dataset.cursorActive !== 'true') cursorHide();
    if (root.dataset.motionActive !== 'true') all('[data-reveal],[data-split],[data-reveal-image]').forEach(node => node.classList.add('is-revealed'));
    document.dispatchEvent(new CustomEvent('hp:motion-change'));
  };
  const cursor = document.getElementById('hp-cursor');
  const mouse = { x: 0, y: 0, tx: 0, ty: 0, visible: false, frame: 0 };
  function cursorHide() { mouse.visible = false; cursor?.classList.remove('is-visible'); cancelAnimationFrame(mouse.frame); mouse.frame = 0; }
  const cursorFrame = () => {
    mouse.frame = 0;
    if (!mouse.visible || !cursor) return;
    mouse.x += (mouse.tx - mouse.x) * .18;
    mouse.y += (mouse.ty - mouse.y) * .18;
    cursor.style.transform = `translate3d(${mouse.x}px,${mouse.y}px,0) translate(-50%,-50%)`;
    if (Math.abs(mouse.tx - mouse.x) + Math.abs(mouse.ty - mouse.y) > .15) mouse.frame = requestAnimationFrame(cursorFrame);
  };
  const magnets = new WeakMap();
  let activeMagnet;
  function resetMagnet() {
    if (activeMagnet) { activeMagnet.style.removeProperty('--hp-mx'); activeMagnet.style.removeProperty('--hp-my'); magnets.delete(activeMagnet); activeMagnet = null; }
  }
  document.addEventListener('pointermove', event => {
    if (!fine.matches || event.pointerType === 'touch') return;
    const button = event.target.closest('.hp-button');
    if (button) {
      const rect = button.getBoundingClientRect();
      button.style.setProperty('--hp-bx', `${100 * (event.clientX - rect.left) / Math.max(1, rect.width)}%`);
      button.style.setProperty('--hp-by', `${100 * (event.clientY - rect.top) / Math.max(1, rect.height)}%`);
    }
    const magnet = event.target.closest('[data-magnet]:not(html)');
    if (activeMagnet !== magnet) resetMagnet();
    if (magnet && root.dataset.magnet !== 'false' && root.dataset.motionActive === 'true') {
      activeMagnet = magnet;
      if (!magnets.has(magnet)) magnets.set(magnet, magnet.getBoundingClientRect());
      const rect = magnets.get(magnet);
      const strength = Math.min(16, Number.parseFloat(getComputedStyle(root).getPropertyValue('--hp-magnet')) || 8);
      magnet.style.setProperty('--hp-mx', `${Math.max(-1,Math.min(1,(event.clientX - rect.left - rect.width / 2) / Math.max(rect.width / 2, 1))) * strength}px`);
      magnet.style.setProperty('--hp-my', `${Math.max(-1,Math.min(1,(event.clientY - rect.top - rect.height / 2) / Math.max(rect.height / 2, 1))) * strength}px`);
    }
    const target = event.target.closest('[data-cursor]');
    if (!target || !cursor || target === root || root.dataset.cursorActive !== 'true' || document.querySelector('dialog[open]') || event.target.closest('button:not([data-image-zoom]),.hp-button,input')) { cursorHide(); return; }
    mouse.tx = event.clientX;
    mouse.ty = event.clientY;
    if (!mouse.visible) { mouse.x = mouse.tx; mouse.y = mouse.ty; }
    mouse.visible = true;
    if (!cursor.dataset.dragState) cursor.querySelector('span').textContent = HP.text(`general.${target.dataset.cursor}`);
    cursor.dataset.kind = target.dataset.cursor;
    cursor.classList.add('is-visible');
    if (!mouse.frame) mouse.frame = requestAnimationFrame(cursorFrame);
  }, { passive: true });
  document.addEventListener('pointerout', event => { if (!event.relatedTarget) { cursorHide(); resetMagnet(); } });
  window.addEventListener('blur', () => { cursorHide(); resetMagnet(); });
  let scrollFrame = 0;
  const parallaxElements = new Set();
  const scrollUpdate = () => {
    scrollFrame = 0;
    const header = document.querySelector('.hp-header');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 50);
    parallaxElements.forEach(node => {
      if (!node.isConnected) { parallaxElements.delete(node); return; }
      if (root.dataset.motionActive !== 'true') { node.style.removeProperty('transform'); return; }
      const rect = node.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const y = Math.max(-28, Math.min(28, (rect.top + rect.height / 2 - innerHeight / 2) * .045));
      node.style.transform = `translate3d(0,${y}px,0)`;
    });
    const sticky = document.querySelector('[data-main-product=true] [data-sticky-buy]');
    const add = document.querySelector('[data-main-product=true] [data-add-button]');
    if (sticky && add) { const visible = add.getBoundingClientRect().bottom < 0; sticky.classList.toggle('is-visible', visible); sticky.inert = !visible; sticky.setAttribute('aria-hidden', String(!visible)); sticky.querySelector('button').disabled = add.disabled; }
  };
  window.addEventListener('scroll', () => { resetMagnet(); cursorHide(); if (!scrollFrame) scrollFrame = requestAnimationFrame(scrollUpdate); }, { passive: true });
  initHooks.push(scope => { all('[data-parallax]', scope).forEach(node => parallaxElements.add(node)); scrollUpdate(); });
  const header = document.querySelector('.hp-header');
  if (header && 'ResizeObserver' in window) new ResizeObserver(entries => root.style.setProperty('--hp-header-height', `${entries[0].borderBoxSize?.[0]?.blockSize || header.offsetHeight}px`)).observe(header);
  const slideshows = new WeakMap();
  initHooks.push(scope => all('[data-slideshow]', scope).forEach(show => {
    if (slideshows.has(show)) return;
    const slides = all('[data-slide]', show);
    const track = show.querySelector('.hp-slides');
    if (!track || !slides.length) return;
    const hint = show.querySelector('[data-drag-hint]');
    const status = show.querySelector('[data-slide-status]');
    let index = 0, timer, settleTimer, gesture = null, settling = false, pendingIndex = null, blockedClickUntil = 0, paused = false, hovering = false, focusing = false, visible = true;
    const interval = Number(show.dataset.autoplay) || 0;
    const wrap = value => (value + slides.length) % slides.length;
    const resetCursor = () => {
      if (!cursor?.dataset.dragState) return;
      delete cursor.dataset.dragState;
      delete cursor.dataset.direction;
      cursor.style.removeProperty('--hp-drag-progress');
      cursor.querySelector('span').textContent = HP.text('general.drag');
    };
    const sync = announce => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      all('[data-slide-to]', show).forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      if (announce && status) status.textContent = HP.text('accessibility.slide', { number: index + 1, total: slides.length });
    };
    const clearDrag = () => {
      clearTimeout(settleTimer);
      const hadDrag = track.classList.contains('is-dragging') || track.classList.contains('is-settling');
      if (hadDrag) { track.classList.add('is-dragging'); track.classList.remove('is-settling'); }
      if (pendingIndex !== null) { index = pendingIndex; pendingIndex = null; sync(true); }
      const pointer = gesture?.id;
      gesture = null;
      settling = false;
      track.style.removeProperty('--hp-drag-progress');
      delete track.dataset.dragDirection;
      slides.forEach(slide => { slide.classList.remove('is-drag-neighbor'); slide.style.removeProperty('--hp-drag-x'); });
      if (hadDrag) void track.offsetWidth;
      track.classList.remove('is-dragging', 'is-settling');
      resetCursor();
      if (hint) hint.textContent = HP.text(fine.matches ? 'general.drag_discover' : 'general.swipe_discover');
      if (pointer !== undefined && track.hasPointerCapture?.(pointer)) track.releasePointerCapture(pointer);
    };
    const schedule = () => {
      clearTimeout(timer);
      if (slides.length > 1 && interval > 0 && !gesture && !settling && !paused && !hovering && !focusing && visible && !document.hidden && !reduced.matches && root.dataset.motion !== 'false' && show.isConnected) timer = setTimeout(() => select(index + 1), interval);
    };
    const select = (next, announce = false) => {
      clearDrag();
      index = wrap(next);
      sync(announce);
      schedule();
    };
    show.addEventListener('click', event => { if (event.detail > 0 && performance.now() < blockedClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    show.addEventListener('click', event => {
      const step = event.target.closest('[data-slide-step]');
      const dot = event.target.closest('[data-slide-to]');
      const pause = event.target.closest('[data-slide-pause]');
      if (step) select(index + Number(step.dataset.slideStep), true);
      if (dot) select(Number(dot.dataset.slideTo), true);
      if (pause) { paused = !paused; pause.setAttribute('aria-label', HP.text(`accessibility.${paused ? 'play' : 'pause'}_slides`)); pause.setAttribute('aria-pressed', String(paused)); pause.classList.toggle('is-paused', paused); schedule(); }
    });
    show.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') hovering = true; schedule(); });
    show.addEventListener('pointerleave', () => { hovering = false; schedule(); });
    show.addEventListener('focusin', () => { focusing = true; schedule(); });
    show.addEventListener('focusout', event => { focusing = show.contains(event.relatedTarget); schedule(); });
    show.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input,textarea,select,a')) return;
      event.preventDefault();
      select(index + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    all('img', track).forEach(image => { image.draggable = false; });
    track.addEventListener('dragstart', event => event.preventDefault());
    const move = event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.moving) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        if (Math.abs(dy) >= Math.abs(dx)) { clearDrag(); schedule(); return; }
        gesture.moving = true;
        track.classList.add('is-dragging');
      }
      if (event.cancelable) event.preventDefault();
      const now = performance.now();
      gesture.velocity = (event.clientX - gesture.lastX) / Math.max(1, now - gesture.lastTime);
      gesture.lastX = event.clientX;
      gesture.lastTime = now;
      gesture.dx = Math.max(-gesture.width, Math.min(gesture.width, dx));
      const direction = dx < 0 ? 1 : -1;
      const neighbor = wrap(index + direction);
      const progress = Math.min(1, Math.abs(dx) / gesture.threshold);
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-drag-neighbor', i === neighbor);
        if (i === index || i === neighbor) slide.style.setProperty('--hp-drag-x', `${gesture.dx + (i === neighbor ? direction * gesture.width : 0)}px`);
        else slide.style.removeProperty('--hp-drag-x');
      });
      gesture.direction = direction;
      track.dataset.dragDirection = direction === 1 ? 'next' : 'previous';
      track.style.setProperty('--hp-drag-progress', progress);
      if (hint) hint.textContent = HP.text(progress === 1 ? 'general.release_discover' : `general.${direction === 1 ? 'next_pick' : 'previous_pick'}`);
      if (cursor && event.pointerType !== 'touch' && root.dataset.cursorActive === 'true') {
        cursor.dataset.dragState = progress === 1 ? 'ready' : 'holding';
        cursor.dataset.direction = track.dataset.dragDirection;
        cursor.style.setProperty('--hp-drag-progress', progress);
        cursor.querySelector('span').textContent = HP.text(progress === 1 ? 'general.release' : 'general.drag');
      }
    };
    track.addEventListener('pointerdown', event => {
      if (slides.length < 2 || event.button !== 0 || event.isPrimary === false || gesture || event.target.closest('a,button,input,textarea,select,video,[contenteditable=true]')) return;
      clearDrag();
      const width = track.getBoundingClientRect().width;
      if (width <= 0) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, lastTime: performance.now(), width, threshold: Math.min(140, Math.max(64, width * .15)), dx: 0, velocity: 0, direction: 1, moving: false };
      clearTimeout(timer);
      track.setPointerCapture?.(event.pointerId);
    });
    track.addEventListener('pointermove', move, { passive: false });
    track.addEventListener('pointerup', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      if (!gesture.moving) { clearDrag(); schedule(); return; }
      const { dx, width, threshold, direction, velocity, lastTime, id } = gesture;
      const commit = Math.abs(dx) >= threshold || (Math.abs(dx) >= 36 && performance.now() - lastTime < 100 && Math.abs(velocity) > .55 && Math.sign(velocity) === Math.sign(dx));
      blockedClickUntil = performance.now() + 400;
      gesture = null;
      settling = true;
      pendingIndex = commit ? wrap(index + direction) : null;
      track.classList.add('is-settling');
      track.classList.remove('is-dragging');
      slides[index].style.setProperty('--hp-drag-x', `${commit ? -direction * width : 0}px`);
      slides[wrap(index + direction)].style.setProperty('--hp-drag-x', `${commit ? 0 : direction * width}px`);
      resetCursor();
      if (track.hasPointerCapture?.(id)) track.releasePointerCapture(id);
      const finish = () => { clearDrag(); schedule(); };
      if (reduced.matches || root.dataset.motion === 'false') finish();
      else settleTimer = setTimeout(finish, 520);
    });
    const cancelDrag = () => { clearDrag(); schedule(); };
    track.addEventListener('pointercancel', event => { if (gesture?.id === event.pointerId) cancelDrag(); });
    track.addEventListener('lostpointercapture', event => { if (gesture?.id === event.pointerId) cancelDrag(); });
    window.addEventListener('blur', cancelDrag);
    window.addEventListener('resize', cancelDrag);
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('hp:motion-change', cancelDrag);
    let observer;
    if ('IntersectionObserver' in window) { observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }); observer.observe(show); }
    cleanups.set(show, () => { clearDrag(); clearTimeout(timer); observer?.disconnect(); window.removeEventListener('blur', cancelDrag); window.removeEventListener('resize', cancelDrag); document.removeEventListener('visibilitychange', schedule); document.removeEventListener('hp:motion-change', cancelDrag); });
    slideshows.set(show, select);
    select(0);
  }));
  document.addEventListener('shopify:block:select', event => {
    const show = event.target.closest('[data-slideshow]');
    if (show) { const slides = all('[data-slide]', show); const index = slides.findIndex(node => node.dataset.blockId === event.detail?.blockId); if (index >= 0) slideshows.get(show)?.(index); }
  });
  const carousels = new WeakSet();
  const announcements = new WeakSet();
  initHooks.push(scope => all('[data-announcements]', scope).forEach(node => {
    if (announcements.has(node)) return;
    announcements.add(node);
    const items = all('[data-announcement-item]', node);
    if (items.length < 2) return;
    let index = 0, timer, paused = false, interaction = false;
    const schedule = () => {
      clearTimeout(timer);
      if (paused || interaction || reduced.matches || root.dataset.motion === 'false' || document.hidden || !node.isConnected) return;
      timer = setTimeout(() => {
        index = (index + 1) % items.length;
        items.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.inert = i !== index; item.setAttribute('aria-hidden', String(i !== index)); });
        schedule();
      }, 5000);
    };
    node.querySelector('[data-announcement-pause]')?.addEventListener('click', event => {
      paused = !paused;
      const button = event.currentTarget;
      button.setAttribute('aria-label', HP.text(paused ? 'general.play' : 'general.pause'));
      button.setAttribute('aria-pressed', String(paused));
      schedule();
    });
    node.addEventListener('pointerenter', () => { interaction = true; schedule(); });
    node.addEventListener('pointerleave', () => { interaction = false; schedule(); });
    node.addEventListener('focusin', () => { interaction = true; schedule(); });
    node.addEventListener('focusout', event => { interaction = node.contains(event.relatedTarget); schedule(); });
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('hp:motion-change', schedule);
    cleanups.set(node, () => { clearTimeout(timer); document.removeEventListener('visibilitychange', schedule); document.removeEventListener('hp:motion-change', schedule); });
    schedule();
  }));
  initHooks.push(scope => all('[data-drag-scroll]', scope).forEach(track => {
    if (carousels.has(track)) return;
    carousels.add(track);
    let down, dragged = false;
    track.addEventListener('pointerdown', event => {
      if (!fine.matches || event.button !== 0 || event.target.closest('button,input,select')) return;
      down = { x: event.clientX, scroll: track.scrollLeft };
      dragged = false;
    });
    track.addEventListener('pointermove', event => {
      if (!down) return;
      const distance = event.clientX - down.x;
      if (Math.abs(distance) > 8) { dragged = true; track.classList.add('is-dragging'); track.setPointerCapture?.(event.pointerId); track.scrollLeft = down.scroll - distance; }
    });
    const stop = () => { down = null; track.classList.remove('is-dragging'); };
    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', stop);
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; } }, true);
  }));
  const selectTab = (tab, focus) => {
    const list = tab.closest('[role=tablist]');
    if (!list) return;
    all('[role=tab]', list).forEach(button => {
      const selected = button === tab;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) { panel.hidden = !selected; if (selected) HP.init(panel); }
    });
    if (focus) tab.focus();
  };
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[role=tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = all('[role=tab]', tab.closest('[role=tablist]'));
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault(); selectTab(tabs[next], true);
  });
  document.addEventListener('click', event => {
    const tab = event.target.closest('[role=tab]');
    if (tab) selectTab(tab, false);
    const arrow = event.target.closest('[data-carousel-step]');
    if (arrow) {
      const track = arrow.closest('[data-carousel]').querySelector('[data-drag-scroll]');
      track.scrollBy({ left: Number(arrow.dataset.carouselStep) * (track.firstElementChild?.getBoundingClientRect().width + 24 || track.clientWidth * .85), behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    const thumb = event.target.closest('[data-gallery-select]');
    if (thumb && !thumb.closest('[data-product-gallery]')) {
      const gallery = thumb.closest('[data-gallery]');
      all('[data-media-id]', gallery).forEach(node => node.classList.toggle('hp-gallery-main', node.dataset.mediaId === thumb.dataset.gallerySelect));
      all('[data-gallery-select]', gallery).forEach(node => node.setAttribute('aria-pressed', String(node === thumb)));
    }
    const hotspot = event.target.closest('[data-lookbook-index]');
    if (hotspot) {
      const scene = hotspot.closest('[data-lookbook]');
      all('[data-lookbook-card]', scene).forEach(node => { node.hidden = node.dataset.lookbookCard !== hotspot.dataset.lookbookIndex; if (!node.hidden) HP.init(node); });
      all('[data-lookbook-index]', scene).forEach(node => node.setAttribute('aria-pressed', String(node === hotspot)));
    }
    const marqueeButton = event.target.closest('[data-marquee-toggle]');
    if (marqueeButton) {
      const track = marqueeButton.parentElement.querySelector('[data-marquee]');
      const paused = track.style.animationPlayState !== 'paused';
      track.style.animationPlayState = paused ? 'paused' : 'running';
      marqueeButton.setAttribute('aria-label', HP.text(`general.${paused ? 'play' : 'pause'}`));
      marqueeButton.setAttribute('aria-pressed', String(paused));
      marqueeButton.classList.toggle('is-paused', paused);
    }
    const videoButton = event.target.closest('[data-video-toggle]');
    if (videoButton) {
      const video = videoButton.closest('section').querySelector('video');
      if (!video) return;
      const play = video.paused;
      video.dataset.userPaused = String(!play);
      if (play) video.play().catch(() => HP.toast(HP.text('general.error'))); else video.pause();
      videoButton.setAttribute('aria-label', HP.text(`general.${play ? 'pause' : 'play'}`));
      videoButton.classList.toggle('is-playing', play);
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-image-range]')) event.target.closest('[data-image-comparison]').style.setProperty('--hp-compare-position', `${event.target.value}%`);
  });
  const videos = new WeakSet();
  initHooks.push(scope => all('.hp-banner-media video', scope).forEach(video => {
    if (videos.has(video)) return;
    videos.add(video);
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !reduced.matches && root.dataset.motion !== 'false' && video.dataset.userPaused !== 'true') video.play().catch(() => {});
      else video.pause();
    }, { threshold: .3 });
    observer.observe(video);
    const pause = () => { if (reduced.matches || document.hidden) video.pause(); };
    document.addEventListener('visibilitychange', pause);
    document.addEventListener('hp:motion-change', pause);
    cleanups.set(video, () => { observer.disconnect(); document.removeEventListener('visibilitychange', pause); document.removeEventListener('hp:motion-change', pause); });
  }));
  reduced.addEventListener('change', updateMotion);
  fine.addEventListener('change', updateMotion);
  window.addEventListener('resize', updateMotion, { passive: true });
  document.addEventListener('shopify:section:load', event => HP.init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    [event.target, ...all('*', event.target)].forEach(node => { cleanups.get(node)?.(); revealObserver?.unobserve(node); parallaxElements.delete(node); });
  });
  updateMotion();
  HP.init();
})();

(() => {
  'use strict';
  const HP = window.HP;
  if (!HP) return;
  const galleries = new WeakMap();
  const reduced = () => HP.reduced.matches || document.documentElement.dataset.motion === 'false';
  function initGallery(gallery) {
    if (galleries.has(gallery)) return;
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = HP.all('[data-gallery-slide]', gallery);
    if (!track || !slides.length) return;
    const thumbs = HP.all('[data-gallery-select]', gallery);
    let index = Math.min(slides.length - 1, Math.max(0, Number(gallery.dataset.initialIndex) || 0));
    let settleTimer, motionFrame = 0, moving = false, drag = null, suppressClickUntil = 0;
    let lastWidth = track.clientWidth;
    const clampIndex = value => Math.max(0, Math.min(slides.length - 1, value));
    const nearest = () => track.clientWidth ? clampIndex(Math.round(track.scrollLeft / track.clientWidth)) : index;
    const warm = value => {
      slides.slice(Math.max(0, value - 1), value + 2).forEach(slide => slide.querySelectorAll('img').forEach(img => {
        if (img.loading === 'eager') return;
        img.loading = 'eager';
        img.decoding = 'async';
        img.decode?.().catch(() => {});
      }));
    };
    const cancelMotion = (restoreSnap = true) => {
      cancelAnimationFrame(motionFrame);
      motionFrame = 0;
      moving = false;
      clearTimeout(settleTimer);
      if (restoreSnap) track.classList.remove('is-moving');
    };
    const update = value => {
      index = clampIndex(value);
      slides.forEach((slide, i) => {
        const active = i === index;
        const wasActive = slide.classList.contains('is-active');
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('hp-gallery-main', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) {
          slide.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
          slide.querySelectorAll('iframe').forEach(frame => {
            if (wasActive) frame.src = frame.src;
          });
        }
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.gallerySelect === slides[index].dataset.mediaId)));
      const counter = gallery.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      const previous = gallery.querySelector('[data-gallery-step="-1"]');
      const next = gallery.querySelector('[data-gallery-step="1"]');
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      gallery.dataset.activeMedia = slides[index].dataset.mediaId;
      warm(index);
    };
    const go = (value, instant = false) => {
      cancelMotion(false);
      update(value);
      const from = track.scrollLeft, width = track.clientWidth, left = index * width;
      const distance = left - from;
      track.classList.add('is-moving');
      const finish = () => {
        if (typeof track.scrollTo === 'function') track.scrollTo({ left, behavior: 'instant' });
        else track.scrollLeft = left;
        cancelMotion();
      };
      if (instant || reduced() || !width || Math.abs(distance) < .5) finish();
      else {
        moving = true;
        const started = performance.now();
        const duration = Math.min(580, 360 + Math.abs(distance) / width * 100);
        const frame = now => {
          if (!gallery.isConnected) { cancelMotion(); return; }
          const progress = reduced() ? 1 : Math.min(1, (now - started) / duration);
          track.scrollLeft = from + distance * (1 - Math.pow(1 - progress, 4));
          if (progress < 1) motionFrame = requestAnimationFrame(frame);
          else finish();
        };
        motionFrame = requestAnimationFrame(frame);
      }
      const selectedThumb = thumbs[index];
      if (selectedThumb && selectedThumb.parentElement.clientWidth) {
        const rail = selectedThumb.parentElement;
        const leftEdge = selectedThumb.offsetLeft, rightEdge = leftEdge + selectedThumb.offsetWidth;
        if (leftEdge < rail.scrollLeft || rightEdge > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: Math.max(0, leftEdge - rail.clientWidth / 2 + selectedThumb.offsetWidth / 2), behavior: reduced() ? 'instant' : 'smooth' });
      }
    };
    galleries.set(gallery, { go, slides });
    gallery.classList.add('is-enhanced');
    gallery.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-select]');
      const arrow = event.target.closest('[data-gallery-step]');
      if (thumb) go(slides.findIndex(slide => slide.dataset.mediaId === thumb.dataset.gallerySelect));
      if (arrow) go(index + Number(arrow.dataset.galleryStep));
    });
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.target.closest('video,iframe,model-viewer')) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      track.focus({ preventScroll: true });
    });
    const settle = () => {
      clearTimeout(settleTimer);
      if (!moving && !drag && track.clientWidth) update(nearest());
    };
    track.addEventListener('scroll', () => {
      clearTimeout(settleTimer);
      if (!moving && !drag) settleTimer = setTimeout(settle, 120);
    }, { passive: true });
    track.addEventListener('scrollend', settle, { passive: true });
    track.addEventListener('wheel', () => { if (moving) { cancelMotion(); update(nearest()); } }, { passive: true });
    track.addEventListener('dragstart', event => { if (event.target.matches('img')) event.preventDefault(); });
    track.addEventListener('pointerdown', event => {
      if (event.isPrimary === false || event.button !== 0 || slides.length < 2 || event.target.closest('video,iframe,model-viewer')) return;
      cancelMotion(false);
      update(nearest());
      drag = { x: event.clientX, y: event.clientY, left: track.scrollLeft, width: track.clientWidth, id: event.pointerId, moved: false, lastX: event.clientX, time: performance.now(), velocity: 0 };
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const delta = event.clientX - drag.x;
      if (!drag.moved) {
        const vertical = Math.abs(event.clientY - drag.y);
        if (vertical > 8 && vertical > Math.abs(delta)) { drag = null; go(nearest()); return; }
        if (Math.abs(delta) <= 7) return;
        drag.moved = true;
        track.setPointerCapture?.(drag.id);
        track.classList.add('is-moving', 'is-dragging');
      }
      event.preventDefault();
      const now = performance.now();
      drag.velocity = .5 * drag.velocity + .5 * (drag.lastX - event.clientX) / Math.max(16, now - drag.time);
      drag.lastX = event.clientX; drag.time = now;
      track.scrollLeft = Math.max(0, Math.min((slides.length - 1) * drag.width, drag.left - delta));
    });
    const release = event => {
      if (!drag || (event.pointerId != null && event.pointerId !== drag.id)) return;
      const { moved, id, width, velocity, time } = drag;
      const projected = event.type === 'pointerup' && performance.now() - time < 100 ? Math.max(-width * .35, Math.min(width * .35, velocity * 160)) : 0;
      const target = width ? Math.round((track.scrollLeft + projected) / width) : index;
      drag = null; track.classList.remove('is-dragging');
      if (track.hasPointerCapture?.(id)) track.releasePointerCapture(id);
      if (moved) suppressClickUntil = Date.now() + 300;
      go(target);
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);
    track.addEventListener('pointerleave', event => { if (drag && !drag.moved) release(event); });
    track.addEventListener('click', event => { if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    let observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(() => {
        const width = track.clientWidth;
        if (!width || Math.abs(width - lastWidth) < .5) return;
        lastWidth = width;
        if (drag) {
          const id = drag.id; drag = null; track.classList.remove('is-dragging');
          if (track.hasPointerCapture?.(id)) track.releasePointerCapture(id);
        }
        go(index, true);
      });
      observer.observe(track);
    }
    gallery.addEventListener('hp:gallery-destroy', () => { cancelMotion(); observer?.disconnect(); }, { once: true });
    requestAnimationFrame(() => { if (gallery.isConnected) go(index, true); });
  }
  HP.selectProductMedia = (gallery, mediaId) => {
    const state = galleries.get(gallery);
    if (!state || !mediaId) return false;
    const index = state.slides.findIndex(slide => slide.dataset.mediaId === String(mediaId));
    if (index < 0) return false;
    state.go(index);
    return true;
  };
  HP.initHooks.push(scope => HP.all('[data-product-gallery]', scope).forEach(initGallery));
  document.addEventListener('shopify:section:unload', event => HP.all('[data-product-gallery]', event.target).forEach(gallery => gallery.dispatchEvent(new Event('hp:gallery-destroy'))));
})();

(() => {
  'use strict';
  const HP = window.HP;
  if (!HP) return;
  const { all, config } = HP;
  const t = HP.text;
  const textAt = (selector, value, scope = document) => { const node = scope.querySelector(selector); if (node) node.textContent = value; };
  const getHTML = async (url, signal) => {
    const response = await fetch(HP.url(url), { signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(t('general.error'));
    return HP.parse(await response.text());
  };
  const endpoint = name => config.routes?.[name] || `${config.routes?.root || '/'}cart/${name}.js`;
  let cartBusy = false;
  let cartNote = config.note || '';
  const busy = (element, state) => {
    if (!element) return;
    element.setAttribute('aria-busy', String(state));
    all('button[type=submit],[data-bundle-add]', element).forEach(button => {
      if (state) { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; }
      else if ('wasDisabled' in button.dataset) { button.disabled = button.dataset.wasDisabled === 'true'; delete button.dataset.wasDisabled; }
    });
  };
  const cartFeedback = message => {
    all('[data-cart-feedback]').forEach(node => node.textContent = message);
    if (message) HP.toast(message);
  };
  const replaceCart = async data => {
    const active = document.activeElement;
    const focusKey = active?.closest('[data-cart-line]')?.dataset.cartLine;
    const focusRole = active?.matches('[data-cart-quantity]') ? 'input' : active?.matches('[data-cart-step]') ? active.dataset.cartStep : null;
    const focusOffer = active?.dataset.cartOffer;
    let sections = data.sections;
    if (!sections?.['cart-drawer'] || !sections?.['cart-count']) {
      try {
        const url = HP.url(config.routes.cart);
        url.searchParams.set('sections', 'cart-drawer,cart-count');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error();
        sections = await response.json();
      } catch { cartFeedback(t('cart.refresh_error')); return false; }
    }
    if (!sections?.['cart-drawer'] || !sections?.['cart-count']) { cartFeedback(t('cart.refresh_error')); return false; }
    const drawerDoc = HP.parse(sections['cart-drawer']);
    const contents = drawerDoc.querySelector('[data-cart-contents]');
    const old = document.querySelector('#hp-cart [data-cart-contents]');
    if (!contents || !old) { cartFeedback(t('cart.refresh_error')); return false; }
    const scrollTop = old.querySelector('.hp-cart-scroll')?.scrollTop || 0;
    const openDisclosures = all('[data-cart-disclosure][open]', old).map(node => node.dataset.cartDisclosure);
    old.replaceWith(contents);
    all('[data-cart-disclosure]', contents).forEach(node => node.open = openDisclosures.includes(node.dataset.cartDisclosure));
    const count = HP.parse(sections['cart-count']).querySelector('[data-cart-count-fragment]')?.textContent || contents.dataset.cartCountValue || '0';
    all('[data-cart-count]').forEach(node => node.textContent = count);
    if (typeof data.note === 'string') cartNote = data.note;
    HP.init(contents);
    const scroller = contents.querySelector('.hp-cart-scroll');
    if (scroller) scroller.scrollTop = scrollTop;
    const page = document.querySelector('[data-cart-page]');
    if (page) {
      try {
        const url = HP.url(config.routes.cart);
        url.searchParams.set('section_id', 'main-cart');
        const doc = await getHTML(url);
        const next = doc.querySelector('[data-cart-page]');
        if (next) { page.replaceWith(next); HP.init(next); }
      } catch { cartFeedback(t('cart.refresh_error')); }
    }
    if (focusKey && focusRole) {
      const scope = document.querySelector('dialog[open]') || document;
      const line = all('[data-cart-line]', scope).find(node => node.dataset.cartLine === focusKey);
      const target = focusRole === 'input' ? line?.querySelector('input') : line?.querySelector(`[data-cart-step="${focusRole}"]`);
      (target || document.querySelector('#hp-cart [data-close-dialog]'))?.focus({ preventScroll: true });
    }
    if (focusOffer) {
      const scope = document.querySelector('dialog[open]') || document;
      all('[data-offer-copy]', scope).find(node => node.dataset.offerCopy === focusOffer)?.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('hp:cart-updated', { detail: data }));
    return true;
  };
  const refreshCart = async () => {
    const response = await fetch(HP.url(config.routes.cart + '.js'), { credentials: 'same-origin' });
    if (!response.ok) throw new Error(t('general.error'));
    const cart = await response.json();
    await replaceCart(cart);
    return cart;
  };
  const mutate = async (kind, payload, source, errorNode, openAfter = false) => {
    if (cartBusy) return null;
    cartBusy = true;
    busy(source, true);
    if (errorNode) errorNode.textContent = '';
    const headers = { Accept: 'application/json' };
    let body;
    if (payload instanceof FormData) {
      payload.set('sections', 'cart-drawer,cart-count');
      payload.set('sections_url', new URL(document.baseURI).pathname);
      body = payload;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify({ ...payload, sections: ['cart-drawer', 'cart-count'], sections_url: new URL(document.baseURI).pathname });
    }
    try {
      const response = await fetch(HP.url(endpoint(kind)), { method: 'POST', headers, credentials: 'same-origin', body });
      const data = await response.json();
      if (!response.ok) {
        const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : t('general.error');
        const error = new Error(message); error.confirmed = true; throw error;
      }
      const refreshed = await replaceCart(data);
      if (openAfter) {
        HP.close(document.getElementById('hp-quick-view'), true);
        if (config.cartDrawer !== false) HP.open('hp-cart', source?.querySelector('button') || source);
        else window.location.assign(config.routes.cart);
        if (refreshed) cartFeedback(t('product.added'));
      }
      return data;
    } catch (error) {
      const message = error.confirmed ? error.message : t('cart.uncertain');
      try { await refreshCart(); } catch {}
      if (errorNode?.isConnected) errorNode.textContent = message;
      cartFeedback(message);
      return null;
    } finally { cartBusy = false; busy(source, false); }
  };
  const addProduct = form => {
    const panel = form.closest('[data-product-panel]');
    const data = new FormData(form);
    const feedback = form.querySelector('[data-form-error]');
    if (!data.get('id')) { if (feedback) feedback.textContent = t('product.select_variant'); return; }
    if (panel?.dataset.requiresPlan === 'true' && !data.get('selling_plan')) { if (feedback) feedback.textContent = t('product.subscription'); return; }
    if (form.querySelector('[data-add-button]')?.disabled || !form.reportValidity()) return;
    mutate('add', data, form, feedback, true);
  };
  const changeLine = (key, quantity, source) => {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    mutate('change', { id: key, quantity }, source?.closest('[data-cart-line]'), source?.closest('[data-cart-page],dialog')?.querySelector('[data-cart-feedback]'));
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-product-form]')) { event.preventDefault(); addProduct(form); }
    if (form.matches('[data-cart-page-form]')) {
      event.preventDefault();
      const input = all('[data-cart-quantity]', form).find(node => node.value !== node.defaultValue);
      if (input && input.reportValidity()) changeLine(input.dataset.lineKey, Number(input.value), input);
      else cartFeedback(t('cart.recovered'));
    }
    if (form.matches('[data-note-form]')) {
      event.preventDefault();
      mutate('update', { note: form.elements.note.value }, form, document.querySelector('[data-tool-feedback]')).then(data => {
        if (data) { textAt('[data-tool-feedback]', t('cart.note_saved')); cartNote = form.elements.note.value; }
      });
    }
    if (form.matches('[data-discount-form]')) {
      event.preventDefault();
      const code = form.elements.discount.value.trim();
      if (!code) return;
      mutate('update', { discount: code }, form, document.querySelector('[data-tool-feedback]')).then(data => {
        if (!data) return;
        const codes = code.split(',').map(value => value.trim().toLowerCase());
        const applied = (data.discount_codes || []).some(item => codes.includes(item.code.toLowerCase()) && item.applicable) || (data.cart_level_discount_applications || []).some(item => codes.includes(item.title.toLowerCase()));
        textAt('[data-tool-feedback]', t(applied ? 'cart.discount_applied' : 'cart.discount_invalid'));
      });
    }
  });
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const next = Number(input.value) + Number(step.dataset.quantityStep) * (Number(input.step) || 1);
      input.value = String(Math.max(Number(input.min) || 1, Math.min(input.max ? Number(input.max) : Infinity, next)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const cartStep = event.target.closest('[data-cart-step]');
    if (cartStep) {
      const input = cartStep.parentElement.querySelector('input');
      const min = Number(input.dataset.minimum) || 1;
      let quantity = Math.max(0, Number(input.value) + Number(cartStep.dataset.cartStep) * (Number(input.step) || 1));
      if (quantity > 0 && quantity < min) quantity = Number(cartStep.dataset.cartStep) < 0 ? 0 : min;
      changeLine(input.dataset.lineKey, quantity, cartStep);
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.dataset.cartRemove, 0, remove); }
    const copy = event.target.closest('[data-offer-copy]');
    if (copy) {
      const code = copy.dataset.offerCopy;
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(code).then(() => HP.toast(t('cart.code_copied'))).catch(() => HP.toast(t('cart.code_copy_failed', { code })));
      else HP.toast(t('cart.code_copy_failed', { code }));
    }
    const offer = event.target.closest('[data-cart-offer]');
    if (offer && !offer.disabled && !cartBusy) {
      const code = offer.dataset.cartOffer;
      offer.disabled = true;
      offer.setAttribute('aria-busy', 'true');
      mutate('update', { discount: code }, offer.closest('[data-offer-card]'), document.querySelector('#hp-cart [data-cart-feedback]')).then(data => {
        if (data) {
          const applied = (data.discount_codes || []).some(item => item.code.toUpperCase() === code && item.applicable) || (data.cart_level_discount_applications || []).some(item => item.title.toUpperCase() === code);
          cartFeedback(t(applied ? 'cart.discount_applied' : 'cart.discount_invalid'));
        }
        if (offer.isConnected) { offer.disabled = false; offer.removeAttribute('aria-busy'); }
      });
    }
    const sticky = event.target.closest('[data-sticky-add]');
    if (sticky) {
      const form = sticky.closest('[data-product]').querySelector('[data-product-form]');
      if (form) { const add = form.querySelector('[data-add-button]'); if (add && !add.disabled && form.reportValidity()) form.requestSubmit(add); else { form.scrollIntoView({ behavior: HP.reduced.matches ? 'instant' : 'smooth', block: 'center' }); add?.focus({ preventScroll: true }); } }
    }
    const tool = event.target.closest('[data-cart-tool]');
    if (tool) {
      const name = tool.dataset.cartTool;
      all('[data-tool-panel]').forEach(panel => panel.hidden = panel.dataset.toolPanel !== name);
      textAt('#hp-cart-tool-title', t(`cart.${name}`));
      textAt('[data-tool-feedback]', '');
      const note = document.getElementById('hp-order-note'); if (note) note.value = cartNote;
      HP.open('hp-cart-tool', tool);
    }
    if (event.target.closest('[data-remove-discounts]')) mutate('update', { discount: '' }, document.querySelector('[data-discount-form]'), document.querySelector('[data-tool-feedback]')).then(data => { if (data) textAt('[data-tool-feedback]', t('cart.discount_removed')); });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]') && event.target.reportValidity()) changeLine(event.target.dataset.lineKey, Number(event.target.value), event.target);
  });
  const variantRequests = new WeakMap();
  const selectVariant = async changed => {
    const oldPanel = changed.closest('[data-product-panel]');
    const product = oldPanel.closest('[data-product]');
    variantRequests.get(product)?.abort();
    const controller = new AbortController();
    variantRequests.set(product, controller);
    const selected = all('[data-option-value]:checked,[data-option-select]', oldPanel).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    const valueNode = changed.matches('select') ? changed.selectedOptions[0] : changed;
    const url = HP.url(valueNode?.dataset.productUrl || oldPanel.dataset.productUrl);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values', selected.map(node => node.value).join(','));
    url.searchParams.set('section_id', product.dataset.mainProduct === 'true' ? (product.dataset.sectionId || 'main-product') : 'quick-view');
    const quantity = oldPanel.querySelector('[name=quantity]')?.value;
    oldPanel.setAttribute('aria-busy', 'true');
    oldPanel.querySelector('[data-add-button]').disabled = true;
    try {
      const doc = await getHTML(url, controller.signal);
      if (controller.signal.aborted || variantRequests.get(product) !== controller || !oldPanel.isConnected) return;
      const panel = doc.querySelector('[data-product-panel]');
      if (!panel) throw new Error();
      const oldInstance = oldPanel.dataset.instance;
      const newInstance = panel.dataset.instance;
      all('[id],[for]', panel).forEach(node => {
        for (const attr of ['id', 'for']) if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).replace(newInstance, oldInstance));
      });
      panel.dataset.instance = oldInstance;
      if (product.dataset.mainProduct === 'true' && !panel.querySelector('h1')) { const heading = panel.querySelector('h2'); if (heading) { const h1 = document.createElement('h1'); h1.textContent = heading.textContent; heading.replaceWith(h1); } }
      const qty = panel.querySelector('[name=quantity]');
      if (qty && quantity) {
        const min = Number(qty.min) || 1, step = Number(qty.step) || 1, max = qty.max ? Number(qty.max) : Infinity;
        qty.value = String(Math.min(max, min + Math.max(0, Math.floor((Number(quantity) - min) / step)) * step));
      }
      const focusedName = changed.name;
      const focusedValue = changed.value;
      oldPanel.replaceWith(panel);
      HP.init(product);
      all('[data-option-value],[data-option-select]', panel).find(node => node.name === focusedName && (node.value === focusedValue || node.matches('select')))?.focus({ preventScroll: true });
      if (panel.dataset.featuredImage && !HP.selectProductMedia?.(product.querySelector('[data-product-gallery]'), panel.dataset.featuredMedia)) {
        const main = product.querySelector('.hp-gallery-main');
        const image = main?.querySelector('img');
        if (image) { image.removeAttribute('srcset'); image.src = panel.dataset.featuredImage; }
        const zoom = main?.querySelector('[data-image-zoom]');
        if (zoom) zoom.dataset.imageZoom = panel.dataset.featuredImage;
      }
      const stickyPrice = product.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = panel.querySelector('.hp-product-price')?.innerHTML || '';
      const stickyButton = product.querySelector('[data-sticky-add]');
      if (stickyButton) stickyButton.disabled = panel.querySelector('[data-add-button]').disabled;
      if (product.dataset.mainProduct === 'true') {
        const nextURL = HP.url(panel.dataset.productUrl);
        if (panel.dataset.variantId) nextURL.searchParams.set('variant', panel.dataset.variantId);
        else nextURL.searchParams.set('option_values', selected.map(node => node.value).join(','));
        try { history.replaceState({}, '', nextURL); } catch {}
      }
      document.dispatchEvent(new CustomEvent('hp:variant-changed', { detail: { product, panel } }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      oldPanel.removeAttribute('aria-busy');
      textAt('[data-form-error]', t('product.variant_error'), oldPanel);
    }
  };
  document.addEventListener('change', event => { if (event.target.matches('[data-option-value],[data-option-select]')) selectVariant(event.target); });
  let quickController;
  const quickView = async button => {
    quickController?.abort();
    const controller = quickController = new AbortController();
    const content = document.querySelector('[data-quick-view-content]');
    content.textContent = t('general.loading');
    const url = HP.url(button.dataset.quickView);
    url.searchParams.set('section_id', 'quick-view');
    HP.open('hp-quick-view', button);
    try {
      const doc = await getHTML(url, controller.signal);
      if (controller.signal.aborted) return;
      const product = doc.querySelector('[data-product]');
      if (!product) throw new Error();
      content.replaceChildren(product);
      HP.init(content);
      remember(product.dataset.productHandle);
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.replaceChildren();
      const p = document.createElement('p'); p.textContent = t('general.error');
      const a = document.createElement('a'); a.className = 'hp-link'; a.href = button.dataset.quickView; a.textContent = t('general.details');
      content.append(p, a);
    }
  };
  document.addEventListener('click', event => {
    const quick = event.target.closest('[data-quick-view]');
    if (quick) { event.preventDefault(); quickView(quick); }
    const swatch = event.target.closest('[data-card-swatch]');
    if (swatch) {
      const card = swatch.closest('[data-product-card]');
      all('[data-card-link]', card).forEach(link => link.href = swatch.dataset.url);
      all('[data-quick-view]', card).forEach(button => button.dataset.quickView = swatch.dataset.url);
      if (swatch.dataset.image) { const image = card.querySelector('.hp-card-primary'); if (image) { image.removeAttribute('srcset'); image.src = swatch.dataset.image; } }
      textAt('[data-card-price]', swatch.dataset.price, card);
      all('[data-card-swatch]', card).forEach(node => { node.setAttribute('aria-pressed', String(node === swatch)); node.classList.toggle('is-selected', node === swatch); });
    }
    const share = event.target.closest('[data-share]');
    if (share) {
      const url = HP.url(share.dataset.share).href;
      if (navigator.share) navigator.share({ url }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => HP.toast(t('general.copied'))).catch(() => HP.toast(url));
      else HP.toast(url);
    }
  });
  const readList = key => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)).slice(0, 8) : []; } catch { return []; } };
  const writeList = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  let recent = readList('hp:recent:v1');
  const fragments = new Map();
  const productFragment = async handle => {
    if (!fragments.has(handle)) {
      const url = HP.url(`${config.routes.root}products/${encodeURIComponent(handle)}`);
      url.searchParams.set('section_id', 'product-card');
      fragments.set(handle, getHTML(url).then(doc => {
        const card = doc.querySelector('[data-product-card]');
        if (!card) throw new Error();
        return card;
      }).catch(error => { fragments.delete(handle); throw error; }));
    }
    return (await fragments.get(handle)).cloneNode(true);
  };
  let fragmentInstance = 0;
  const uniqueCard = card => {
    fragmentInstance++;
    all('[id]', card).forEach(node => node.id += `-fragment-${fragmentInstance}`);
    return card;
  };
  const recentStates = new WeakMap();
  const renderRecent = scope => all('[data-recent-products]', scope).forEach(async container => {
    const disclosure = container.closest('[data-cart-disclosure]');
    if (disclosure && !disclosure.open) return;
    const signature = recent.slice(0, 4).join(',');
    if (recentStates.get(container) === signature || !signature) return;
    recentStates.set(container, signature);
    const results = await Promise.allSettled(recent.slice(0, 4).map(productFragment));
    if (!container.isConnected || recentStates.get(container) !== signature) return;
    const cards = results.filter(result => result.status === 'fulfilled').map(result => uniqueCard(result.value));
    if (cards.length) { container.replaceChildren(...cards); HP.init(container); }
  });
  function remember(handle) {
    if (!config.recentlyViewed || !handle || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) return;
    recent = [handle, ...recent.filter(item => item !== handle)].slice(0, 8);
    writeList('hp:recent:v1', recent);
    renderRecent(document);
    renderSearchRecent();
  }
  HP.initHooks.push(renderRecent);
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-cart-disclosure="recent"]') && event.target.open) renderRecent(event.target);
  }, true);
  let searchRecentSequence = 0;
  async function renderSearchRecent() {
    const dialog = document.getElementById('hp-search');
    const list = dialog?.querySelector('[data-search-recent]');
    if (!dialog?.open || !list) return;
    const sequence = ++searchRecentSequence;
    const handles = config.recentlyViewed ? recent.slice(0, 4) : [];
    const signature = handles.join(',');
    if (list.dataset.signature === signature) return;
    const cards = await Promise.allSettled(handles.map(productFragment));
    if (sequence !== searchRecentSequence || !list.isConnected) return;
    const rows = cards.filter(item => item.status === 'fulfilled').map(item => {
      const card = item.value;
      const source = card.querySelector('[data-card-link]');
      if (!source) return null;
      let href;
      try { href = HP.url(source.getAttribute('href')).href; } catch { return null; }
      const li = document.createElement('li');
      const link = document.createElement('a'); link.className = 'hp-search-product'; link.href = href;
      const media = document.createElement('span'); media.className = 'hp-search-product-image';
      const originalImage = card.querySelector('.hp-card-primary,img');
      if (originalImage) { const image = originalImage.cloneNode(true); image.alt = ''; image.removeAttribute('id'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.loading = 'lazy'; media.append(image); }
      const info = document.createElement('span'); info.className = 'hp-search-product-info';
      const title = document.createElement('strong'); title.textContent = card.querySelector('h3')?.textContent.trim() || source.getAttribute('aria-label') || '';
      const price = document.createElement('span'); price.textContent = card.querySelector('[data-card-price]')?.textContent.trim() || '';
      info.append(title, price); link.append(media, info);
      const arrow = dialog.querySelector('.hp-search-heading .hp-icon'); if (arrow) link.append(arrow.cloneNode(true));
      li.append(link); return li;
    }).filter(Boolean);
    list.replaceChildren(...rows); list.hidden = rows.length === 0;
    list.dataset.signature = signature;
    const fallback = dialog.querySelector('[data-search-fallback]'); if (fallback) fallback.hidden = rows.length > 0;
    textAt('[data-search-discovery-title]', t(rows.length ? 'search.recent' : 'search.discover'), dialog);
    textAt('[data-search-discovery-note]', t(rows.length ? 'search.recent_note' : 'search.discover_note'), dialog);
  }
  HP.initHooks.push(scope => { if (scope.id === 'hp-search' || scope.querySelector('#hp-search')) renderSearchRecent(); });
  let searchTimer, searchController, searchSequence = 0, paneTimer, paneFrame;
  const searchCache = new Map();
  const searchMode = searching => {
    const body = document.querySelector('[data-search-body]');
    if (!body) return;
    const discovery = body.querySelector('[data-search-discovery]');
    const results = body.querySelector('[data-search-results-pane]');
    const active = searching ? results : discovery, inactive = searching ? discovery : results;
    clearTimeout(paneTimer); cancelAnimationFrame(paneFrame);
    body.dataset.searchMode = searching ? 'results' : 'discover';
    inactive.inert = true; inactive.setAttribute('aria-hidden', 'true');
    active.hidden = false;
    paneFrame = requestAnimationFrame(() => { active.inert = false; active.setAttribute('aria-hidden', 'false'); });
    paneTimer = setTimeout(() => { inactive.hidden = true; }, HP.reduced.matches || document.documentElement.dataset.motion === 'false' ? 0 : 290);
    body.querySelector('[data-search-clear]').hidden = !searching;
  };
  const updateSearch = input => {
    clearTimeout(searchTimer); searchController?.abort();
    const sequence = ++searchSequence;
    const output = document.getElementById('hp-search-results');
    const query = input.value.trim();
    input.setAttribute('aria-expanded', 'false');
    searchMode(query.length > 0);
    if (!query) { output.replaceChildren(); output.removeAttribute('aria-busy'); renderSearchRecent(); return; }
    output.classList.add('hp-search-status'); output.textContent = t('search.searching'); output.setAttribute('aria-busy', 'true');
    const showResults = html => {
      if (sequence !== searchSequence || input.value.trim() !== query) return;
      const doc = HP.parse(html), results = doc.querySelector('.hp-predictive-results');
      output.classList.remove('hp-search-status'); output.removeAttribute('aria-busy');
      if (results) { output.replaceChildren(results); input.setAttribute('aria-expanded', String(!!results.querySelector('a'))); }
      else output.textContent = t('search.none');
    };
    if (searchCache.has(query.toLowerCase())) { showResults(searchCache.get(query.toLowerCase())); return; }
    searchTimer = setTimeout(async () => {
      const controller = searchController = new AbortController();
      const url = HP.url(config.routes.suggest);
      url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6'); url.searchParams.set('section_id', 'predictive-search');
      try {
        const doc = await getHTML(url, controller.signal);
        if (controller.signal.aborted || sequence !== searchSequence) return;
        const html = doc.body.innerHTML;
        if (searchCache.size >= 12) searchCache.delete(searchCache.keys().next().value);
        searchCache.set(query.toLowerCase(), html); showResults(html);
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === searchSequence) { output.removeAttribute('aria-busy'); output.textContent = t('general.error'); }
      }
    }, 180);
  };
  document.addEventListener('input', event => { if (event.target.matches('[data-predictive-search]')) updateSearch(event.target); });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-search-clear]')) return;
    const input = document.querySelector('[data-predictive-search]'); input.value = ''; updateSearch(input); input.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (event.target.matches('[data-predictive-search]') && event.key === 'ArrowDown') {
      event.preventDefault();
      const selector = event.target.value.trim() ? '#hp-search-results a' : '#hp-search-discovery ul:not([hidden]) a';
      document.querySelector(selector)?.focus();
    }
  });
  let filterController;
  const filterPage = async (urlValue, sectionID, push = true) => {
    filterController?.abort(); const controller = filterController = new AbortController();
    const root = document.querySelector('[data-collection-root]');
    if (!root) return;
    const url = HP.url(urlValue), destination = new URL(url);
    url.searchParams.set('section_id', sectionID);
    root.setAttribute('aria-busy', 'true');
    try {
      const doc = await getHTML(url, controller.signal);
      if (controller.signal.aborted) return;
      const next = doc.querySelector('[data-collection-root]');
      if (!next) throw new Error();
      all('dialog[open]', root).forEach(dialog => HP.close(dialog, true));
      root.replaceWith(next);
      if (push) { try { history.pushState({ hpFilter: true }, '', destination); } catch {} }
      HP.init(next);
      const target = next.querySelector('[data-product-grid],.hp-product-grid');
      if (target) { target.tabIndex = -1; target.focus({ preventScroll: true }); target.scrollIntoView({ block: 'start', behavior: HP.reduced.matches ? 'instant' : 'smooth' }); }
    } catch (error) {
      if (error.name === 'AbortError') return;
      root.removeAttribute('aria-busy');
      HP.toast(t('general.error'));
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-filter-form]')) return;
    event.preventDefault();
    const url = HP.url(form.action); url.search = '';
    for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
    filterPage(url, form.dataset.sectionId);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-filter-link],.hp-pagination a,.hp-filter-bottom>a');
    const root = link?.closest('[data-collection-root]');
    if (root) { event.preventDefault(); filterPage(link.href, root.dataset.sectionId); }
    const toggle = event.target.closest('[data-toggle-product-view]');
    if (toggle) {
      const active = toggle.getAttribute('aria-pressed') !== 'true';
      toggle.setAttribute('aria-pressed', String(active));
      toggle.closest('[data-collection-root]').classList.toggle('hp-alternate-view', active);
    }
  });
  window.addEventListener('popstate', () => { const root = document.querySelector('[data-collection-root]'); if (root) filterPage(location.href, root.dataset.sectionId, false); });
  const bundleItems = bundle => all('[data-bundle-check]:checked', bundle).map(check => {
    const card = check.closest('.hp-bundle-card');
    const option = card.querySelector('[data-bundle-variant]')?.selectedOptions[0];
    return option && !option.disabled && !check.disabled ? { id: Number(option.value), quantity: Number(option.dataset.quantity) || 1, price: Number(option.dataset.price), title: card.querySelector('h3').textContent.trim() } : null;
  }).filter(Boolean);
  const updateBundle = bundle => {
    const items = bundleItems(bundle);
    textAt('[data-bundle-count]', t(items.length ? 'bundle.count' : 'bundle.select', { count: items.length }), bundle);
    textAt('[data-bundle-total]', HP.money(items.reduce((sum, item) => sum + item.price * item.quantity, 0)), bundle);
    const list = bundle.querySelector('[data-bundle-selected]');
    list.replaceChildren(...items.map(item => { const p = document.createElement('p'); const title = document.createElement('span'); title.textContent = `${item.title}${item.quantity > 1 ? ` × ${item.quantity}` : ''}`; const price = document.createElement('span'); price.textContent = HP.money(item.price * item.quantity); p.append(title, price); return p; }));
    bundle.querySelector('[data-bundle-add]').disabled = items.length === 0;
  };
  HP.initHooks.push(scope => all('[data-bundle]', scope).forEach(updateBundle));
  document.addEventListener('change', event => { if (event.target.matches('[data-bundle-check],[data-bundle-variant]')) updateBundle(event.target.closest('[data-bundle]')); });
  document.addEventListener('click', event => {
    const add = event.target.closest('[data-bundle-add]');
    if (!add) return;
    const bundle = add.closest('[data-bundle]');
    const items = bundleItems(bundle).map(({ id, quantity }) => ({ id, quantity }));
    if (!items.length) return;
    mutate('add', { items }, bundle, bundle.querySelector('[data-bundle-feedback]'), true);
  });
  const recommendations = new WeakSet();
  HP.initHooks.push(scope => all('[data-recommendations]', scope).forEach(node => {
    if (recommendations.has(node)) return;
    recommendations.add(node);
    const load = async () => {
      try { const doc = await getHTML(node.dataset.url); const next = doc.querySelector('[data-recommendations]'); if (next?.querySelector('[data-product-card]')) { node.replaceWith(next); recommendations.add(next); HP.init(next); } else node.hidden = true; }
      catch { node.hidden = true; }
    };
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { observer.disconnect(); load(); } }, { rootMargin: '200px' }); observer.observe(node); }
    else load();
  }));
  HP.initHooks.push(scope => {
    remember(scope.querySelector('[data-main-product=true]')?.dataset.productHandle);
  });
  HP.init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-conversion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hp-pdp-buybox')) {
  class HappyPicksBuybox extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-pdp-copy]');
        if (!button) return;
        const code = button.dataset.pdpCopy;
        const feedback = this.querySelector('[data-copy-feedback]');
        const label = button.querySelector('[data-copy-label]');
        if (!navigator.clipboard?.writeText) {
          feedback.textContent = `${feedback.dataset.copyFailed}: ${code}`;
          return;
        }
        navigator.clipboard.writeText(code).then(() => {
          if (!this.isConnected) return;
          feedback.textContent = `${code} ${button.dataset.copied}`;
          const current = label.textContent;
          label.textContent = button.dataset.copied;
          setTimeout(() => { if (label.isConnected) label.textContent = current; }, 2200);
        }).catch(() => { if (this.isConnected) feedback.textContent = `${feedback.dataset.copyFailed}: ${code}`; });
      }, { signal });
      this.addEventListener('play', event => {
        if (event.target.tagName === 'VIDEO') this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
      }, { capture: true, signal });
      const rating = this.querySelector('[data-pdp-rating]');
      const updateRating = () => {
        const count = Number(rating?.querySelector('[data-number-of-reviews]')?.dataset.numberOfReviews || 0);
        const empty = rating?.querySelector('[data-empty-review]');
        const link = rating?.querySelector('[data-rated-review]');
        if (empty) empty.hidden = count > 0;
        if (link) link.hidden = count === 0;
      };
      if (rating) {
        this.reviewObserver = new MutationObserver(updateRating);
        this.reviewObserver.observe(rating, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
        updateRating();
      }
      const timeline = this.querySelector('[data-pdp-timeline]');
      if (timeline) {
        this.updateTimeline(timeline);
        this.clock = setInterval(() => { if (!document.hidden) this.updateTimeline(timeline); }, 1000);
        document.addEventListener('visibilitychange', () => this.updateTimeline(timeline), { signal });
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.reviewObserver?.disconnect();
      clearInterval(this.clock);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    updateTimeline(timeline) {
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone:'Asia/Kolkata', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' }).formatToParts(now);
      const fields = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const indianDay = Date.UTC(Number(fields.year), Number(fields.month)-1, Number(fields.day));
      const dayMs = 86400000;
      let formatter;
      try { formatter = new Intl.DateTimeFormat(timeline.dataset.locale || 'en-IN', { day:'numeric', month:'short', timeZone:'UTC' }); }
      catch { formatter = new Intl.DateTimeFormat('en-IN', { day:'numeric', month:'short', timeZone:'UTC' }); }
      const format = value => formatter.format(new Date(value));
      const setText = (selector, value) => { const node = timeline.querySelector(selector); if (node && node.textContent !== value) node.textContent = value; };
      const minimum = Math.max(1, Number(timeline.dataset.deliveryMin) || 5);
      const maximum = Math.max(minimum, Number(timeline.dataset.deliveryMax) || 7);
      setText('[data-order-date]', format(indianDay));
      setText('[data-delivery-date]', `${format(indianDay + minimum * dayMs)} – ${format(indianDay + maximum * dayMs)}`);
      if (timeline.dataset.cutoffEnabled !== 'true') return;
      const hour = Math.min(23, Math.max(0, Number(timeline.dataset.cutoffHour) || 0));
      const minute = Math.min(59, Math.max(0, Number(timeline.dataset.cutoffMinute) || 0));
      let cutoffDay = indianDay;
      let cutoffInstant = cutoffDay + hour * 3600000 + minute * 60000 - 19800000;
      if (now.getTime() >= cutoffInstant) cutoffDay += dayMs;
      while (new Date(cutoffDay).getUTCDay() === 0) cutoffDay += dayMs;
      cutoffInstant = cutoffDay + hour * 3600000 + minute * 60000 - 19800000;
      let dispatchDay = cutoffDay;
      let processing = Math.max(0, Number(timeline.dataset.dispatchDays) || 0);
      while (processing > 0) { dispatchDay += dayMs; if (new Date(dispatchDay).getUTCDay() !== 0) processing--; }
      const left = Math.max(0, Math.floor((cutoffInstant - now.getTime()) / 1000));
      const clock = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60].map(n => String(n).padStart(2,'0')).join(':');
      setText('[data-countdown-clock]', clock);
      setText('[data-countdown-dispatch]', format(dispatchDay));
      setText('[data-dispatch-date]', format(dispatchDay));
      timeline.querySelector('[data-pdp-countdown]').hidden = false;
    }
  }
  customElements.define('hp-pdp-buybox', HappyPicksBuybox);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selvorn-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('selvorn-product')) {
  customElements.define('selvorn-product', class extends HTMLElement {
    connectedCallback() {
      if (this.svReady) return;
      this.svReady = true;
      this.mainImage = this.querySelector('.sv-main-image');
      this.viewer = this.querySelector('.sv-viewer');
      this.viewerImage = this.querySelector('[data-sv-viewer-image]');
      this.viewerTitle = this.querySelector('.sv-viewer-toolbar h2');
      this.caption = this.querySelector('[data-sv-gallery-caption]');
      this.imageLabel = 'Guide cover';
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-sv-thumb]');
        if (thumb && this.mainImage) {
          this.querySelectorAll('[data-sv-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
          this.mainImage.removeAttribute('srcset');
          this.mainImage.src = thumb.dataset.imageSrc;
          this.mainImage.alt = thumb.dataset.imageAlt;
          this.imageLabel = thumb.dataset.imageLabel;
          this.caption.textContent = this.imageLabel + ' · Tap to enlarge';
          this.querySelector('.sv-cover-button').setAttribute('aria-label', 'Enlarge ' + this.imageLabel.toLowerCase());
        }
        const enlarge = event.target.closest('[data-sv-enlarge]');
        const sample = event.target.closest('[data-sv-sample]');
        if (enlarge && this.mainImage) this.openImage(this.mainImage.src, this.mainImage.alt, this.imageLabel, enlarge);
        if (sample) this.openImage(sample.dataset.imageSrc, sample.dataset.imageAlt, sample.dataset.imageAlt, sample);
        if (event.target.closest('[data-sv-close]')) this.viewer.close();
      });
      this.viewer.addEventListener('click', event => { if (event.target === this.viewer) { const bounds = this.viewer.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.viewer.close(); } });
      this.viewer.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.viewer.close(); } });
      this.viewer.addEventListener('close', () => { if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus(); });
      this.querySelectorAll('[data-sv-thumb]').forEach(button => button.addEventListener('keydown', event => { if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); const buttons = Array.from(this.querySelectorAll('[data-sv-thumb]')); let position = buttons.indexOf(button); if (event.key === 'ArrowRight') position = (position + 1) % buttons.length; if (event.key === 'ArrowLeft') position = (position - 1 + buttons.length) % buttons.length; if (event.key === 'Home') position = 0; if (event.key === 'End') position = buttons.length - 1; buttons[position].focus(); buttons[position].click(); }));
    }
    openImage(src, alt, title, trigger) {
      this.returnFocus = trigger;
      this.viewerImage.src = src;
      this.viewerImage.alt = alt;
      this.viewerTitle.textContent = title;
      if (!this.viewer.open) this.viewer.showModal();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tracker-dashboard-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = scope => scope.querySelectorAll('[data-section="preview"]').forEach(preview => {
    if (preview.dataset.tdReady) return;
    const inputs = [...preview.querySelectorAll('#habit-rows input[type="checkbox"]')];
    if (!inputs.length) return;
    preview.dataset.tdReady = 'true';
    const draw = () => {
      const complete = inputs.filter(input => input.checked).length;
      preview.querySelector('[data-td-ring]')?.style.setProperty('--td-completion', `${complete / inputs.length}turn`);
      preview.querySelector('[data-td-done]')?.style.setProperty('--td-fill', `${complete / inputs.length * 100}%`);
      preview.querySelectorAll('[data-td-habit]').forEach(row => {
        const habitInputs = inputs.filter(input => input.dataset.habit === row.dataset.tdHabit);
        const count = habitInputs.filter(input => input.checked).length;
        const total = habitInputs.length;
        row.style.setProperty('--td-fill', `${total ? count / total * 100 : 0}%`);
        row.querySelector('[data-td-count]').textContent = `${count} / ${total}`;
        const bar = row.querySelector('[role="progressbar"]');
        bar.setAttribute('aria-valuenow', String(count));
        bar.setAttribute('aria-valuemax', String(total));
      });
    };
    preview.addEventListener('change', event => {
      if (event.target.matches('#habit-rows input')) draw();
    });
    preview.addEventListener('click', event => {
      if (event.target.closest('.reset-demo')) requestAnimationFrame(draw);
    });
    draw();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
